module.exports = __webpack_public_path__ + "static/media/loading.5a50eb6d.svg";